import FlashMessage from './FlashMessage.vue';

export default FlashMessage;
